import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Title from './dev/Title';
import Input from './dev/Input'
import Submit from './dev/Submit';
import LoadingSpinner from '../dev/LoadingSpinner';


const { REACT_APP_URI = '/' } = process.env
class OldMemberChangePassword extends Component  {
    state= {
        registerPassword: '',
        nextRegisterPassword: '',
        isPasswordMatch: '',
        isButtonActive: false,
        isLoading: false,
        response: '',
    }

    profileInput = condition => e => {
        const { target: { value } } = e;
        this.setState({[`${condition}`]: value }, () => this.matchPassword())
    }
    matchPassword = () => {
        const { registerPassword, nextRegisterPassword } = this.state
        if (registerPassword === '' || nextRegisterPassword === '') return;
        if (registerPassword === nextRegisterPassword) this.setState({isPasswordMatch: true})
        else this.setState({ isPasswordMatch: false })
    }
    profileSubmit = () => {
        if (this.state.isPasswordMatch === false) return
        this.setState({ isLoading: true})
        const { email, token } = this.props.user
        const { nextRegisterPassword } = this.state
        fetch(`${REACT_APP_URI}/accounts/oldUserSetPassword/`, {
            method: 'post',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": token,
            },
            body: JSON.stringify({ email: email, password: nextRegisterPassword })
        })
        .then(res => {
            const { status } = res
            if (status === 200) { this.setState({ response: 'messages.user_signup_success', isLoading: false });}
            if (status === 400) { this.setState({ response: 'Unknown Error', isLoading: false });}
        })
    }
    
    isButtonActive = () => {
        if (this.state.isPasswordMatch) return ''
        else return 'disabled'
    }

    render() {
        const { user: { email }, messages } = this.props
        const { registerPassword, nextRegisterPassword, isPasswordMatch, response, isLoading } = this.state
        const { profileInput, profileSubmit,isButtonActive } =this
        return (
            <Container>
                <div>
                    <Title>舊會員重設密碼</Title>
                    <Input type="email" name="email" placeholder={email} autoFocus />
                    <Input
                        onInput={profileInput('registerPassword')} value={registerPassword}
                        onKeyPress={e => e.key === "Enter" && profileSubmit()}
                        type="password" placeholder={messages.user_password_signup} />
                    <Input
                        onInput={profileInput('nextRegisterPassword')} value={nextRegisterPassword}
                        onKeyPress={e => e.key === "Enter" && profileSubmit()}
                        type="password" placeholder={messages.user_confirm_password} />
                    {isPasswordMatch === false && <Footer>{messages.user_password_not_match}</Footer>}
                    {isLoading && <LoadingSpinner/>}
                    <Submit onClick={() =>profileSubmit()} disabled={isButtonActive()} >發送驗證信</Submit>
                </div>
                <Footer>{response}</Footer>
            </Container>
      )
    }
}
const mapStateToProps = state => {
    return {
        user: state.User,
        messages: state.Messages
    }
}
export default connect(mapStateToProps)(OldMemberChangePassword);
const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    min-height: 270px;
`
const Footer = styled.div`
    display: flex;    
    width: 100%;
    font-size: 14px;
    font-weight: 300;
    color: #de0606;
`


// WEBPACK FOOTER //
// ./src/User/OldMemberChangePassword.js